import React, { useEffect, useState } from 'react';
import { GoogleMap, Marker, InfoWindow, MarkerClusterer, useLoadScript } from '@react-google-maps/api';
import config from '../../../../../../application/config/config';
import getCoordsCenter from './utils/getCoordsCenter';

const libraries = ['places'];
const DEFAULT_CENTER = { lat: -23.534594212639348, lng: -46.66121639661013 };

const ClusterMap = (props) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: config.gmaps_key,
    libraries,
  });

  const [mapCenter, setMapCenter] = useState(DEFAULT_CENTER);
  const [zoomLevel, setZoomLevel] = useState(props.zoomLevel || 10);
  const [selectedMarker, setSelectedMarker] = useState(null);

  useEffect(() => {
    if (props.coords.length > 0) {
      const allCoordinates = props.coords.map(coord => [coord.lat, coord.lng]);
      const centerOfAllCoords = getCoordsCenter(allCoordinates);
      setMapCenter({ lat: centerOfAllCoords[0], lng: centerOfAllCoords[1] });
    } else {
      setMapCenter(DEFAULT_CENTER);
    }
  }, [props.coords]);

  useEffect(() => {
    if (selectedMarker) {
      setMapCenter({ lat: selectedMarker.lat, lng: selectedMarker.lng });
      setSelectedMarker(selectedMarker);
    }
  }, [selectedMarker]);

  const handleMarkerClick = coord => {
    setSelectedMarker(coord);
    setMapCenter({ lat: coord.lat, lng: coord.lng });
    setZoomLevel(15);
  };

  const handleCloseInfoWindow = () => {
    setSelectedMarker(null);
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%' }}
      center={mapCenter}
      zoom={zoomLevel}
    >
      <MarkerClusterer>
        {(clusterer) =>
          props.coords.map((coord, index) => (
            <Marker
              key={index}
              position={{ lat: coord.lat, lng: coord.lng }}
              onClick={() => handleMarkerClick(coord)}
              clusterer={clusterer}
            >
              {selectedMarker && selectedMarker.lat === coord.lat && (
                <InfoWindow
                  onCloseClick={handleCloseInfoWindow}
                  position={{ lat: coord.lat, lng: coord.lng }}
                >
                  <div>
                    {coord.description}
                  </div>
                </InfoWindow>
              )}
            </Marker>
          ))
        }
      </MarkerClusterer>
    </GoogleMap>
  ) : null;
};

export default ClusterMap;
